import React, { useEffect, useState, useContext } from 'react';
import {
  doc,
  getDoc
} from 'firebase/firestore';

import {
  db
} from "../utils/firebase";

import { TokenContext } from "./tokenContext"; // import TokenContext
import { logout } from "../utils/firebase";
import { createPortal } from "react-dom";
import GlobalNavDrawer from "./GlobalNavDrawer";
import { useAuth } from './AuthContext';
import axios from "axios";
import "./JobBankContact.css";

export default function JobBankContact() {
  const { balance, setBalance } = useContext(TokenContext);
  const { currentUser } = useAuth();
  const [sent, setSent] = useState(false);
  useEffect(() => {
        let isMounted = true;
    
        const fetchTokens = async () => {
          if (!currentUser?.uid) return;
    
          const userRef = doc(db, "users", currentUser.uid);
    
          try {
            const userDoc = await getDoc(userRef);
    
            if (userDoc.exists() && isMounted) {
              setBalance(userDoc.data().tokens ?? 0);
            }
          } catch (error) {
            console.error("Error fetching token count:", error);
          }
        };
    
        fetchTokens();
    
        return () => {
          isMounted = false;
        };
      }, [currentUser, setBalance]);

  const handleSubmit = async (e) => {

    e.preventDefault();

    const formData =
      new FormData(e.target);

    try {

      await axios.post(
        "https://fluency.ispeakwell.ca/api/send-email",
        {
          name: formData.get("name"),
          email: formData.get("email"),
          message: formData.get("message"),
        }
      );

      setSent(true);

    } catch (err) {

      console.error(err);
    }
  };

  return (

    <div className="JBC-container">

      <h1>
        Community Job Bank
      </h1>

      <h2>
        Contact Us
      </h2>

      <p className="JBC-intro">
        Questions about hiring,
        applications, career coaching,
        hiring events, or employer services?
        We'd love to hear from you.
      </p>

      <div className="JBC-grid">

        <div className="JBC-card">
          <h3>👤 Job Seekers</h3>
          <p>
            Profiles, resumes,
            applications,
            and employment support.
          </p>
        </div>

        <div className="JBC-card">
          <h3>🏢 Employers</h3>
          <p>
            Job postings,
            applicants,
            and recruitment support.
          </p>
        </div>

        <div className="JBC-card">
          <h3>🎓 Career Coaches</h3>
          <p>
            Client management,
            coaching tools,
            and reporting.
          </p>
        </div>

        <div className="JBC-card">
          <h3>📅 Hiring Events</h3>
          <p>
            Event registration,
            attendance,
            and community engagement.
          </p>
        </div>

      </div>

      {sent ? (

        <div className="JBC-success">
          Thank you for contacting us.
          We will respond shortly.
        </div>

      ) : (

        <form
          className="JBC-form"
          onSubmit={handleSubmit}
        >

          <input
            name="name"
            placeholder="Your Name"
            required
          />

          <input
            name="email"
            type="email"
            placeholder="Email Address"
            required
          />

          <textarea
            name="message"
            placeholder="How can we help?"
            required
          />

          <button type="submit">
            Send Message
          </button>

        </form>

      )}
      {createPortal(
        <GlobalNavDrawer
          hideCurrent
          links={[
            { to: "/purchase", label: `Tokens: ${balance}`},
            { to: "/jobbank", label: "Job Bank Home"},
            { to: "/voicebot", label: "iSpeakWell" },
            { to: "/resumerevisor", label: "Resumes" },
            { to: "/conversationpractice", label: "Convos" },
            { to: "/interview-practice", label: "Interviews" },
            { to: "/termsofservice", label: "Terms" },
            { to: "/privacypolicy", label: "Privacy" },
            { to: "/admin", label: "Admin" },
            { to: "/login", label: "Logout", onClick: async () => { await logout(); } },
          ]}
        />,
          document.body
      )}
    </div>
  );
}